module.exports = __webpack_public_path__ + "static/media/book2.20f7fc83.png";